import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-single-input',
  templateUrl: './single-input.component.html',
  styleUrls: ['./single-input.component.scss']
})

export class SingleInputComponent implements OnInit {

  /**
   * The placeholder to show in the input
   * @internal
   */
  @Input() placeholder: string = '';

  /**
   * Allow to show a tooltip below the input,
   * Default value: false
   * @internal
   */
  @Input() showTooltip: boolean = false;

  /**
   * Text to display if the showTooltip flag is set to true
   * @internal
   */
  @Input() tooltipText: string = '';

  constructor() { }

  ngOnInit(): void {
  }



}
